module.exports = __webpack_public_path__ + "img/pingjia6.a3b09dad.png";